<template>
  <div class="carousel-wrapper" v-if="isManager && cards">
  <div class="carousel-title">
    <ion-icon name="people-outline"> </ion-icon>
    <p>
    {{$t("Minha Equipe")}}
    </p>
  </div>
    <div class="carousel">
      <div class="inner" ref="inner" :style="innerStyles"> 
        <div class="card" v-for="card in cards" :key="card.name" @click="redirectToUserProfile(card.id)">
          <img class="employee-profile-photo" :src="card.photo" v-if="card.photo">

          <div v-else class="employee-profile-photo">

            {{ getNameInitials(card.name) }}
          </div>

          <div class="employee-description-wrapper">
            <div class="employee-name">
              {{ card.name | limitTo(11) }}
            </div>
  
            <div class="employee-job" v-if="card.officeName">
              {{ card.officeName | limitTo(16) }}
            </div>

            <div class="employee-job" v-else>
              {{$t("Sem registro")}}
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22" height="23"
      viewBox="0 0 22 23"
      fill="none"
      @click="prev"
      class="prev-button"
      v-if="this.cards.length > 5"
    >
      <path d="M14.0938 17.6875L7.90625 11.5L14.0937 5.3125" stroke="#9D9D9D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      @click="next"
      class="next-button"
      v-if="this.cards.length > 5"
    >
      <path d="M7.90625 5.3125L14.0938 11.5L7.90625 17.6875" stroke="#9D9D9D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
</template>

<script>
import { UTIL_SERVICE } from '../../../utils';

export default {
  data() {
    return {
      innerStyles: {},
      step: '',
      transitioning: false,
    }
  },
  props: {
    cards: {
      required: true,
    },
    isManager: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  mounted() {
    this.setStep();
    if(this.cards.length > 5) {
      this.resetTranslate();
    }
  },

  methods: {
    getNameInitials (name) {
      const regex = /\b[A-Za-z]/g;
      const initials = (name.match(regex) || [])
          .map(initial => initial.toUpperCase()).slice(0, 2).join('');
      return initials;
    },
    setStep() {
      const innerWidth = this.$refs.inner;
      let totalCards = 1;

      if(this.cards) {
        totalCards = this.cards.length;
      }
      if(innerWidth) {
        this.step = `${innerWidth.scrollWidth / totalCards}px`
      }
    },
    
    next() {
      if(this.transitioning) return

      this.transitioning = true

      this.moveLeft()

      this.afterTransition(() => { 
        const card = this.cards.shift()
        this.cards.push(card);
        this.resetTranslate();
        this.transitioning = false
      })
    },
    prev () {
      if (this.transitioning) return

      this.transitioning = true

      this.moveRight()

      this.afterTransition(() => {
        const card = this.cards.pop()
        this.cards.unshift(card)
        this.resetTranslate()
        this.transitioning = false
      })
    },

    afterTransition(callback) {
      const listener = () => {
        callback()
        this.$refs.inner.removeEventListener('transitionend', listener);
      }
      this.$refs.inner.addEventListener('transitionend', listener);
    },

    resetTranslate () {
      this.innerStyles = {
        transition: 'none', // ❷
        transform: `translateX(-${this.step})`
      }
    },

    moveLeft() {
      this.innerStyles = {
        transform: `translateX(-${this.step})
                    translateX(-${this.step})`
      }
    },

    moveRight() {
      this.innerStyles = {
        transform: `translateX(${this.step})
                    translateX(-${this.step})`
      }
    },
    redirectToUserProfile(id) {
      UTIL_SERVICE.redirectManagerToUserProfile('perfil-do-funcionario', id)
      // this.$router.push(`perfil/2/${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
  .carousel-wrapper {
    transition: 0.5s;
    border-radius: 10px !important;
    border: 1px solid var(--border) !important;
    background: var(--leftMenuColor) !important;
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.07), 2px 2px 7px 0px rgba(0, 0, 0, 0.07);
    min-height: 65px;
    min-width: 100%;
    padding: 0px 10px;
    position: relative;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;

    .carousel-title {
      position: absolute;
      top: -33px;
      left: 3px;
      display: flex;
      gap: 6px;
      align-items: flex-start;
      color: #7E8DA7;
      font-weight: 600;
      font-size: 17px;
      text-align: center;
      
      ion-icon {
        height: 26px;
        width: 26px;
      }
    }

    .prev-button {
      position: absolute;
      left: 14px;
      top: 21px;
      cursor: pointer;
      transition: transform 0.2s;
    }

    .next-button {
      position: absolute;
      right: 14px;
      top: 21px;
      cursor: pointer;
      transition: transform 0.2s;
    }

   .prev-button:hover {
      transform: scale(1.2)
    }

   .next-button:hover {
      transform: scale(1.2)
    }
  }
  .carousel {
    width: 90%;
    overflow: hidden;
    margin-left: 20px;
    margin-right: 20px;
  }

  .inner {
    transition: transform 0.3s;
    display: flex;
    white-space: nowrap;
    gap: 14px;
  }

  .card {
    transition: 0.5s;
    height: 42px;
    width: 151px;
    max-width: 151px;
    min-width: 151px;
    display: inline-flex;
    gap: 4px;
    
  
    /* optional */
    background-color: var(--leftMenuColor);
    color: var(--text);
    align-items: center;
    justify-content: center;

    .employee-profile-photo {
      transition: 0.5s;
      font-size: 12px;
      object-fit: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      border-radius:30px;
      border: 1px solid var(--border);;
      background: #d9d9d9;
      color: #FFF;
      font-weight: 500;
      box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.10);
    }

    .employee-description-wrapper {
      display: flex;
      flex-direction: column;
      .employee-name {
        font-weight: 500;
        font-size: 14px;
        color: var(--text);
        overflow: hidden;
      }
  
      .employee-job {
        overflow: hidden;
        font-weight: 400;
        font-size: 12px;
        color: var(--text);
      }
    }

    
  }

  .card:hover {
    cursor: pointer;
    border-radius: 10px;
    border: 0.5px solid #D9D9D9;
    background: rgba(0, 72, 255, 0.07);
  }
  
  /* optional */

</style>


// WEBPACK FOOTER //
// src/vue/views/components/carousel.vue